module.exports = __webpack_public_path__ + "img/us_quotaIcon.bd4a3db8.png";